/* global wx */

import React, { useState, useEffect, useRef } from 'react';
import AMapLoader from "@amap/amap-jsapi-loader";
import IconButton from '@mui/material/IconButton';
import { Grid, Avatar, Box, Drawer, Container, Rating, Modal, Typography } from '@mui/material/';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AddCommentIcon from '@mui/icons-material/AddComment';
import { useTheme } from '@emotion/react';
import { styled } from "@mui/material/styles";
import { TweenMax, TimelineMax } from "greensock";
import { Back } from 'greensock';

import HeadsetIcon from '@mui/icons-material/Headset';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';

import MapIcon from '@mui/icons-material/Map';


import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import NavigationIcon from '@mui/icons-material/Navigation';
import img_icon0 from "../../assets/icon0.png";
import img_icon1 from "../../assets/icon1.png";
import img_icon2 from "../../assets/icon2.png";
import img_icon3 from "../../assets/icon3.png";
import img_icon4 from "../../assets/icon4.png";
import img_icon5 from "../../assets/icon5.png";
import img_icon6 from "../../assets/icon6.png";
import bt_shop from "../../assets/bt_shop.png";
import img_icon7 from "../../assets/icon7.png";
import img_icon8 from "../../assets/icon8.png";
import img_icon9 from "../../assets/icon9.png";
import img_icon10 from "../../assets/icon10.png";
import img_live from "../../assets/live1.png";

import img_c1 from "../../assets/c1.png";
import img_c2 from "../../assets/c2.png";
import img_c3 from "../../assets/c3.png";
import img_c4 from "../../assets/c4.png";
import img_c5 from "../../assets/c5.png";
import img_c6 from "../../assets/c6.png";
import img_c7 from "../../assets/c7.png";
import img_c8 from "../../assets/c8.png";

import img_add from "../../assets/add.png";
import img_min from "../../assets/min.png";
import img_locate from "../../assets/locate.png";
import { Link, useLocation } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import img_test1 from "../../assets/swiper0.png";
import view0 from "../../assets/view0.jpg";
import view1 from "../../assets/view1.jpg";
import view2 from "../../assets/view2.jpg";
import view3 from "../../assets/view3.jpg";
import YetaiPiece from "../../components/yetaipiece";

import { useSelector, useDispatch } from 'react-redux';
import { fetchScenic } from '../../store/features/map.js';
import { fetchYetai, YetaiFilterByType } from '../../store/features/yetai.js';
import { fetchSplash, SetSplashOpen } from '../../store/features/splash.js';
import { updateSearchValue } from '../../store/features/search.js';
import OpenScreen from '../../components/OpenScreen/index.jsx';
import ScrollingTextList from '../../components/scrolltext/index.jsx';
import BasicSpeedDial from '../../components/SpeedDial/index.jsx';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import HighlightOffSharpIcon from '@mui/icons-material/HighlightOffSharp';
import Line from '../../components/line/index.jsx';

// const data = require('../../assets/data.json');
let lastSearchValue = '';
let lastId = '';
const HOME_STATE_KEY = 'home_state_v3';
const AntTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: theme.palette.mgreen.main,
    '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.mgreen.main,
        top: 'calc(100% - 9px)', // 调整指示器与文字的高度
    },
}));
const AntTab = styled((props) => <Tab {...props} />)(
    ({ theme }) => ({
        textTransform: "none",
        minWidth: 0,
        [theme.breakpoints.up("sm")]: {
            minWidth: 0,
        },
        fontSize: '1.05rem',
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(1),
        color: "rgba(0, 0, 0, 0.85)",
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:hover": {
            color: theme.palette.primary.mainsat,
            opacity: 1,
        },
        "&.Mui-selected": {
            color: theme.palette.mgreen.main,
            fontWeight: theme.typography.fontWeightMedium,
        },
        "&.Mui-focusVisible": {
            backgroundColor: "#d1eaff",
        },
    })
);
const MyTab = (props) => {
    const dispatch = useDispatch();
    // const [value, setValue] = useState("4");

    const handleChange = (event, newValue) => {
        event.stopPropagation();
        event.preventDefault();

        props.change(newValue);
        // setValue(newValue);
        dispatch(YetaiFilterByType(newValue));
    };

    return (
        <Grid className='flex justify-center' >
            <div style={{ display: 'flex', justifyContent: 'center' }}></div>
            <AntTabs
                value={props.tabIdx}
                onChange={handleChange}
            >
                <AntTab value={"4"} label="介绍" />
                <AntTab value={"1"} label="产品" />
                <AntTab value={"2"} label="活动" />

                {/* <AntTab value={"3"} label="活动" /> */}
            </AntTabs>

        </Grid>
    )
}

const MyButton = (props) => {
    return (
        <div onClick={props.onClick} style={props.style} className='flex w-full flex-wrap justify-center items-center content-center mt-5 rounded-lg'
        >
            {props.children}
        </div>
    );
};

const WaterFall = () => {
    const yetaiData = useSelector((store) => store.yetai.filterData);
    const storageURL = process.env.REACT_APP_Stroage_URL;
    let itemData = yetaiData;

    return (
        <Grid sx={{ padding: 2, height: 400, overflowY: 'scroll' }}>
            <ImageList
                variant="masonry" cols={2} gap={8}>
                {
                    itemData && itemData.map((item, index) => (
                        <ImageListItem key={index}>
                            <YetaiPiece data={item}></YetaiPiece>
                        </ImageListItem>
                    ))
                }
                <div style={{ marginBottom: '20px' }}></div>
            </ImageList>
            <div style={{ width: '100%', color: '#999999', textAlign: 'center', margin: '20px auto 100px auto' }}>已经到底了</div>
        </Grid>
    )

}

const JieShao = (props) => {
    // 始终使用 props.data，这是从上层传入的 desc 数据
    const descContent = props?.data || '';
    return (
        descContent &&
        <Container>
            <Grid sx={{ marginTop: "15px", paddingBottom: "40px" }}>
                <Typography component="div" variant="body1" dangerouslySetInnerHTML={{ __html: descContent }} />
            </Grid>
        </Container>
    )
}

const MyPlane = (props) => {

    // 默认进入就是介绍，优先用 props.initialTab，其次用缓存
    const [tabIdx, setTabIdx] = useState(() => {
        if (props.initialTab) return props.initialTab;
        try {
            const savedRaw = sessionStorage.getItem(HOME_STATE_KEY);
            if (savedRaw) {
                const s = JSON.parse(savedRaw);
                if (s?.planeTabIdx) return s.planeTabIdx;
            }
        } catch (e) {
            console.warn('读取缓存 tabIdx 失败', e);
        }
        return "4";
    });

    useEffect(() => {
        if (props.initialTab) {
            setTabIdx(props.initialTab);
        }
    }, [props.initialTab]);

    const updateJieShao = (data) => {
        setTabIdx(data);
        props.onTabChange && props.onTabChange(data);
    }
    // console.log('data',props.data);

    const daohangHandler = (data) => {
        console.log("data", data)
        let lat = data.coordinates.split(',')[1];
        let lng = data.coordinates.split(',')[0];

        // let lat = data.latitude;
        // let lng = data.longitude;

        lat = parseFloat(lat || 0);
        lng = parseFloat(lng || 0);
        wx.openLocation({
            latitude: lat, // 纬度，浮点数，范围为90 ~ -90
            longitude: lng, // 经度，浮点数，范围为180 ~ -180。
            name: data.name, // 位置名
            address: data.addr, // 地址详情说明
            scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为大
        });
    }

    const callHandler = (tel) => {
        if (!tel) return;
        // 在微信环境中使用微信拨号API
        if (typeof wx !== 'undefined' && wx.makePhoneCall) {
            wx.makePhoneCall({
                phoneNumber: tel,
                success: function () {
                    console.log('拨号成功');
                },
                fail: function (err) {
                    console.log('拨号失败', err);
                    // 如果微信API失败，使用tel协议
                    window.location.href = `tel:${tel}`;
                }
            });
        } else {
            // 非微信环境，直接使用tel协议
            window.location.href = `tel:${tel}`;
        }
    }

    const storageURL = process.env.REACT_APP_Stroage_URL;

    return (
        <Drawer
            className=''
            anchor={"bottom"}
            open={props.showplane}
            onClose={props.closeHandler}
            sx={{
                '& .MuiPaper-root': {
                    borderTopLeftRadius: "15px !important",
                    borderTopRightRadius: "15px !important",
                    height: '85vh',
                    maxHeight: '90vh',
                    minHeight: '70vh'
                }
            }}
            ModalProps={{ keepMounted: true }}
            transitionDuration={{ enter: 0, exit: 0 }}
        >
            <IconButton style={{ position: 'absolute', right: '10px', top: "10px" }} aria-label="delete" size="meduim" onClick={props.closeHandler}>
                <HighlightOffSharpIcon fontSize='meduim' />
            </IconButton>
            <Grid sx={{ background: "#ffffff", margin: "10px", padding: '0px 10px 10px 10px', borderRadius: '10px' }}>
                <Grid container spacing={1} marginTop={0}>
                    <Grid item alignContent={"center"} alignItems={'center'} container spacing={1} >
                        <Grid item xs={"auto"}>
                            <Avatar sx={{ width: 70, height: 70 }} alt="Remy Sharp" src={storageURL + props.data.thumb} />
                        </Grid>
                        <Grid item>
                            <Box sx={{ fontWeight: "bold", color: "black", fontSize: '1.2rem', letterSpacing: '2px' }}>{props.data.name}</Box>
                            <Box sx={{ fontWeight: "normal", color: "#999", fontSize: '0.8rem', letterSpacing: '0px' }}>{props.data.addr}</Box>
                        </Grid>

                    </Grid>
                    <Grid item container spacing={1} justifyContent="space-between"
                        alignItems="center" alignContent={'center'}>
                        <Grid item container xs={4}>
                            <Rating size="small" name="half-rating-read" value={Math.min(parseInt(props.data.score) / 20, 5)} precision={0.5} readOnly />
                            <Box sx={{ marginLeft: "4px", fontWeight: "normal", color: "#999", fontSize: '0.8rem', letterSpacing: '0px' }}> {'星级:' + props.data.score}</Box>
                        </Grid>
                        <Grid item container xs={8} spacing={1} justifyContent="flex-end" style={{ fontSize: '0.8rem' }}>

                            <Grid item>
                                {props.data.name != '鄂州特产馆' && <Button
                                    // onClick={() => { window.location.href = 'weixin://dl/business/?appid=wx291475a9fcb22599&path=pages/index/index' }}
                                    onClick={() => { window.location.href = props.data.url }}
                                    style={{ fontSize: '0.6125rem', padding: '2px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                                    color='mgreen'
                                    size="small"
                                    variant="outlined"
                                    startIcon={<ShoppingCartIcon />}
                                    disabled={!props.data.url}
                                    sx={{ '& .MuiButton-startIcon': { marginLeft: 0, marginRight: 0 } }}
                                >
                                    购买商品
                                </Button>}

                                {props.data.name == '鄂州特产馆' && (

                                    <Button
                                        // onClick={() => { window.location.href = 'weixin://dl/business/?appid=wx291475a9fcb22599&path=pages/index/index' }}
                                        style={{ fontSize: '0.6125rem', padding: '2px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',position:'relative' }}
                                        color='mgreen'
                                        size="small"
                                        variant="outlined"
                                        startIcon={<ShoppingCartIcon />}
                                        // disabled={!props.data.url}
                                        sx={{ '& .MuiButton-startIcon': { marginLeft: 0, marginRight: 0 } }}
                                    >
                                        购买商品
                                        <wx-open-launch-weapp
                                        id="launch-btn"
                                        username="gh_749dc4116997"
                                        path="pages/home/dashboard/index"
                                        error={(e) => { console.log('跳转小程序失败', e) }}
                                        launch={(e) => { console.log('跳转小程序成功', e) }}
                                        style={{ display: 'inline-block',position:'absolute',left:0,top:0 }}
                                    >
                                        <script type="text/wxtag-template">
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',backgroundColor: 'rgba(0,0,0,0)' }}>
                                                <img src={bt_shop} style={{ borderRadius: '5px', opacity: 0.0, width: '50px', height: 'auto' }} />
                                            </div>
                                        </script>
                                    </wx-open-launch-weapp>
                                    </Button>


                                )}
                            </Grid>
                            <Grid item>
                                {
                                    props.data.tel &&
                                    <Button
                                        onClick={() => { callHandler(props.data.tel) }}
                                        style={{ fontSize: '0.6125rem', padding: '2px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                                        color='mgreen'
                                        size="small"
                                        variant="outlined"
                                        startIcon={<PhoneInTalkOutlinedIcon />}
                                        sx={{ '& .MuiButton-startIcon': { marginLeft: 0, marginRight: 0 } }}
                                    >
                                        一键拨号
                                    </Button>
                                }
                            </Grid>
                            <Grid item>
                                {
                                    props.data.coordinates &&
                                    <Button
                                        onClick={() => { daohangHandler(props.data) }}
                                        style={{ fontSize: '0.6125rem', padding: '2px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                                        color='mgreen'
                                        size="small"
                                        variant="outlined"
                                        startIcon={<NavigationIcon />}
                                        sx={{ '& .MuiButton-startIcon': { marginLeft: 0, marginRight: 0 } }}
                                    >
                                        地图导航
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <MyTab tabIdx={tabIdx} change={updateJieShao}></MyTab>
            {tabIdx == "4" && (
                <>
                    {props.data.video && (
                        <Container sx={{ mt: 1, mb: 1 }}>
                            <video
                                style={{ width: '100%', borderRadius: '10px', maxHeight: '320px', objectFit: 'cover' }}
                                src={storageURL + props.data.video}
                                controls
                                preload="metadata"
                                poster={props.data.thumb ? storageURL + props.data.thumb : undefined}
                            />
                        </Container>
                    )}
                    <JieShao data={props.data.desc}></JieShao>
                </>
            )}
            {tabIdx != "4" && <WaterFall></WaterFall>}
            <Box display="flex" sx={{ color: "#aaa", fontSize: "0.8rem", margin: "0.5rem" }} justifyContent={"center"} alignItems="center">开发单位：鄂州市农业科学研究所</Box>
            <Box display="flex" sx={{ color: "#aaa", fontSize: "0.8rem", margin: "0.5rem" }} justifyContent={"center"} alignItems="center">冠旭科技提供技术支持</Box>


        </Drawer >
    );
};


const Splash = (props) => {
    const splashData = useSelector((store) => store.splash.data);
    const storageURL = process.env.REACT_APP_Stroage_URL;

    return (
        <Modal
            open={props.open && splashData && splashData.length > 0}
            onClose={props.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Container >
                <Grid sx={{ height: '100vh' }} container justifyContent='center' alignContent='center' alignItems='center'>
                    <Grid item xs={8}>
                        <Swiper
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            spaceBetween={50}
                            slidesPerView={1}
                            pagination={{ clickable: true, type: 'bullets', dynamicBullets: true }}
                        // scrollbar={{ draggable: true }}
                        // onSwiper={(swiper) => console.log(swiper)}
                        // onSlideChange={() => console.log('slide change')}
                        >
                            {/** Slides */}
                            {splashData && splashData.map((item, i) => (
                                <SwiperSlide key={i}>
                                    <a href={item.url}>
                                        <img style={{ 'objectFit': 'cover', borderRadius: '10px', width: '100%', height: "50vh" }} src={storageURL + item.thumb}></img>
                                    </a>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Grid>
                    <Grid item xs={8}>
                        <Box onClick={props.handleClose} sx={{ marginTop: "10px", textAlign: "center", color: 'white' }}><HighlightOffSharpIcon fontSize='large'></HighlightOffSharpIcon></Box>
                    </Grid>
                </Grid>

            </Container>
        </Modal>
    )
}
const isWeChat = () => {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('micromessenger');
};
let map = null;
let marker_locate = null;
let map_driving = null;
let arr_marker = [];
let geolocation = null;
let tileLayer = null;
let imageLayer = null;
export default function Home() {
    const { splash_open } = useSelector(store => store.splash)
    const currentRoute = useSelector((store) => store.line.currentRoute);
    const { searchValue } = useSelector((store) => store.search);
    const { searchObject } = useSelector((store) => store.search);
    const { data: notificationData } = useSelector((store) => store.notification);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    const [showLine, setShowLine] = useState(false);
    const [showplane, setShowplane] = useState(false);
    const [showfilter, setFilter] = useState(false);
    const [showNotificationDrawer, setShowNotificationDrawer] = useState(false);
    const [planedata, setPlanedata] = useState({});
    const [planedataId, setPlanedataId] = useState(null);
    const [planeTabIdx, setPlaneTabIdx] = useState("4");
    const [planeRestored, setPlaneRestored] = useState(false);
    const [boxTop, setBoxTop] = useState();
    const [bool_splash, setBool_splash] = useState(false);
    const [audioPlaying, setAudioPlaying] = useState(false);
    const [isWeChatEnv, setIsWeChatEnv] = useState(false);

    const categoryMap = [
        {
            category_id: 1, range: [
                "水产", "果蔬", "粮油", "肉禽蛋", "特产馆", "其他"
            ]
        },
        {
            category_id: 2, range: [
                "火龙果", "柑橘", "蓝莓", "枇杷", "葡萄", "桑葚", "桃子", "无花果", "西瓜", "杨梅", "柿子", "猕猴桃", "冬枣", "哈密瓜", "小番茄", "草莓"
            ]
        },
        {
            category_id: 3, range: []
        },
        {
            category_id: 4, range: []
        },
        {
            category_id: 5, range: ["美食", "民宿", "美丽乡村"]
        }
    ]

    // 初始化二级面板相关状态，使用第一个分类的默认值
    const defaultCategoryId = 1;
    const defaultRanges = categoryMap.find(item => item.category_id === defaultCategoryId)?.range || [];

    const [subRangeOptions, setSubRangeOptions] = useState(defaultRanges);
    const [selectedCategoryId, setSelectedCategoryId] = useState(defaultCategoryId);
    const [selectedRange, setSelectedRange] = useState('all');
    const [showSubRange, setShowSubRange] = useState(false); // 默认显示二级面板
    const [subRangeTop, setSubRangeTop] = useState(80);
    const firstButtonRef = useRef(null);

    const mapInit = useRef(false);

    const storageURL = process.env.REACT_APP_Stroage_URL;

    // 通过useSelector直接拿到store中定义的value
    const { mapData } = useSelector((store) => store.maps);
    // const yetaiData =;
    const dispatch = useDispatch();

    const closeLineHandler = (newOpen) => () => {
        setShowLine(newOpen);
        // if (newOpen == false) {
        //     setAudioPlaying(false);
        //     window.audio_bg.pause();
        // }
    };

    const toggleDrawer = (newOpen) => () => {
        setShowplane(newOpen);
        if (newOpen == false) {
            setAudioPlaying(false);
            window.audio_bg.pause();
        }
    };
    const voiceHandler = (url) => {
        if (!audioPlaying) {
            if (window.audio_bg) {
                setAudioPlaying(true);
                window.audio_bg.src = process.env.REACT_APP_Stroage_URL + url;
                window.audio_bg.play();
            }
        }
        else {
            setAudioPlaying(false);
            window.audio_bg.pause();
        }


    };

    // 恢复 Home 的 MyPlane 状态
    useEffect(() => {
        const savedRaw = sessionStorage.getItem(HOME_STATE_KEY);
        if (savedRaw) {
            try {
                const s = JSON.parse(savedRaw);
                setTimeout(() => {
                    if (s.planedata) {
                        setPlanedata(s.planedata);
                    }
                    if (s.planedataId) {
                        setPlanedataId(s.planedataId);
                        // 恢复时，planedata 应该已经包含在 s.planedata 中（scenic 数据，包含 desc）
                        // fetchYetai 只用于获取业态列表，不用于设置 planedata
                        dispatch(fetchYetai({ id: s.planedataId }));
                        // 如果 session 中的 planedata 存在，直接使用（它应该是 scenic 数据）
                        // 如果没有，需要从 mapData 中查找对应的 scenic 数据
                        if (!s.planedata && mapData) {
                            const scenicData = Array.isArray(mapData)
                                ? mapData.find(item => item.id === s.planedataId)
                                : (mapData.id === s.planedataId ? mapData : null);
                            if (scenicData) {
                                setPlanedata(scenicData);
                            }
                        }
                    }
                    if (s.planeTabIdx) {
                        console.log("s.planeTabIdx:", s.planeTabIdx);
                        setPlaneTabIdx(s.planeTabIdx);
                    }
                    if (s.showplane) {
                        setShowplane(true);
                    }
                    setPlaneRestored(true);
                    // 使用后立即清除，避免旧值污染下一次会话
                    sessionStorage.removeItem(HOME_STATE_KEY);
                }, 200);
            } catch (e) {
                console.warn('恢复 Home 状态失败', e);
                setPlaneRestored(true);
            }
        } else {
            setPlaneRestored(true);
        }
    }, [dispatch]);

    // 持久化 Home 的 MyPlane 状态
    useEffect(() => {
        if (!planeRestored) return;
        const stateToSave = {
            planedata,
            planedataId,
            showplane,
            planeTabIdx,
        };
        sessionStorage.setItem(HOME_STATE_KEY, JSON.stringify(stateToSave));
    }, [planedata, planedataId, showplane, planeTabIdx, planeRestored]);


    // 设置安全密钥
    window._AMapSecurityConfig = {
        securityJsCode: "3f653db0bd61c3e1ceb1f2ec878efbe1",
    };


    const clickHandler = (e) => {
        // console.log('idx', e)
    }
    const addHandler = (e) => {
        map.zoomIn();
    }
    const minHandler = (e) => {
        map.zoomOut();
    }
    const locateHandler = (e) => {
        // let { lat, lng } = {lat: 30.6552815, lng: 120.784023};
        // map.setZoomAndCenter(11, [lng, lat]);
        // marker_locate?.setPosition([lng, lat]);
        // marker_locate?.show();
        // return
        geolocation.getCurrentPosition(function (status, result) {
            console.log(result)
            if (result.info == 'SUCCESS') {
                let { lat, lng } = result.position;
                map.setZoomAndCenter(11, [lng, lat]);
                marker_locate?.setPosition([lng, lat]);
                marker_locate?.show();
            }
            else {
                if (window.wx_latitude) {
                    let lat = window.wx_latitude;
                    let lng = window.wx_longitude;
                    map.setZoomAndCenter(11, [lng, lat]);
                    marker_locate?.setPosition([lng, lat]);
                    marker_locate?.show();
                }
                else {
                    wx.getLocation({
                        type: "gcj02",
                        success: function (res) {
                            window.wx_latitude = res.latitude;
                            window.wx_longitude = res.longitude;

                            let lat = window.wx_latitude;
                            let lng = window.wx_longitude;
                            map.setZoomAndCenter(11, [lng, lat]);
                            marker_locate?.setPosition([lng, lat]);
                            marker_locate?.show();
                        },
                        cancel: function (res) {
                            // alert("定位失败，权限不足")
                        },
                    });
                    // if (navigator.geolocation) {
                    //     navigator.geolocation.getCurrentPosition(
                    //         (position) => {
                    //             window.wx_latitude = position.coords.latitude;
                    //             window.wx_longitude = position.coords.longitude;
                    //             let lat = window.wx_latitude;
                    //             let lng = window.wx_longitude;
                    //             console.log(lat, lng);
                    //             map.setZoomAndCenter(11, [lng, lat]);
                    //             marker_locate?.setPosition([lng, lat]);
                    //             marker_locate?.show();
                    //         },
                    //         (error) => {
                    //             console.log(error)
                    //         }
                    //     );
                    // } else {

                    // }
                }


            }
        })
    }

    const lineHandler = () => {
        setShowLine(true);
    }

    const showMarkersWithAnimation = (markers = []) => {
        markers.forEach(e => {
            e.show();
            const dom = e.getContentDom()?.parentNode;
            if (dom) {
                dom.style.opacity = '0';
                dom.style.transform = 'translateY(-5px)';
                const ob = { v: 5, opacity: 0 };
                TweenMax.to(ob, 0.7, {
                    delay: Math.random() * 0.5,
                    v: 0,
                    opacity: 1,
                    ease: Back.easeOut,
                    onUpdate: () => {
                        dom.style.opacity = ob.opacity;
                        dom.style.transform = 'translateY(' + ob.v + 'px)';
                    }
                });
            }
        });
    };

    const filterMakerHandler = (idx, range = "all", evt = null) => {
        // 清除搜索，无视之前的搜索过滤
        dispatch(updateSearchValue(''));
        
        if (evt?.currentTarget) {
            const rect = evt.currentTarget.getBoundingClientRect();
            let top = rect.top + window.scrollY;
            // 如果是 category_id 为 2 的按钮，往上偏移一些
            if (idx === 2) {
                top -= 120; // 往上偏移 30px，可以根据需要调整
            }
            setSubRangeTop(top);
        } else if (firstButtonRef.current && idx === 1) {
            // 如果没有事件对象且是默认的第一个分类，使用 ref 获取位置
            const rect = firstButtonRef.current.getBoundingClientRect();
            setSubRangeTop(rect.top + window.scrollY);
        }
        setSelectedCategoryId(idx);
        setSelectedRange(range);
        const ranges = categoryMap.find(item => item.category_id === idx)?.range || [];
        setSubRangeOptions(ranges);
        setShowSubRange(idx !== 0 && idx != 5);

        TweenMax.killAll();
        if (map_driving) {
            map_driving.clear();
        }
        if (map) {
            // map.setFitView();
        }

        if (idx == 0) {
            showMarkersWithAnimation(arr_marker);
        }
        else {
            marker_locate?.hide();
            arr_marker.forEach(e => e.hide());
            let arr = arr_marker.filter(e => {
                const sameCategory = e.customdata?.category_id == idx;
                if (!sameCategory) return false;
                if (range === "all") return true;
                // const markerRange = e.customdata?.range_readable || e.customdata?.range;

                // console.log(e.customdata.range_readable)
                // console.log(e.customdata)
                let match = false;
                e.customdata.range_readable.split('、').forEach(item => {
                    if (item == range) {
                        match = true;
                    }
                });

                return match;
            });
            showMarkersWithAnimation(arr);
        }
    }

    const splashCloseHandler = (e) => {
        setBool_splash(false);
    }


    useEffect(() => {
        let createMap = (s) => {
            let mdata = s.payload.item;
            // if (!mapInit.current) {
            mapInit.current = true;
            AMapLoader.load({
                key: "b59bcb8005f877c7e9c00df89afbbb17",
                // version: "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                // "plugins": [地图用到的插件],           // 需要使用的的插件列表，如比例尺'AMap.Scale'
                plugins: ["AMap.DistrictSearch", 'AMap.MoveAnimation', 'AMap.ImageLayer', 'AMap.TileLayer', 'AMap.Geolocation', 'AMap.Driving'],
            })
                .then((AMap) => {
                    map = new AMap.Map("container", {
                        // 设置地图容器id
                        viewMode: "2D", // 是否为3D地图模式
                        zoom: 10, // 初始化地图级别
                        resizeEnable: true,
                        // center: [116.397428, 39.90923], // 初始化地图中心点位置
                        // center: [120.784023, 30.6552815],
                        center: [114.772254, 30.317099],
                        // resizeEnable: true,
                        cursor: "pointer",
                        layers: [
                            new AMap.TileLayer()
                            // AMap.createDefaultLayer(),
                            //   imageLayer,
                        ],
                        features: ['bg', 'road'],
                        expandZoomRange: true,
                        zooms: [9, 15],
                    });

                    // 创建 TileLayer（用于 zoom <= 15）
                    tileLayer = new AMap.TileLayer({
                        zooms: [9, 15],
                        zIndex: 11,
                        getTileUrl: function (x, y, z) {
                            let nameFormat = "{x}_{y}";
                            let ext = ".png?v=1";
                            var name = nameFormat
                                .replace("{x}", x)
                                .replace("{y}", y)
                                .replace("{z}", z);
                            return 'tiles/' + z + '/tile-' + name + ext;
                        }
                    });

                    // 创建 ImageLayer（用于 zoom > 15）
                    // 需要根据实际情况配置图片 URL 和边界范围
                    // 这里使用示例配置，您可能需要根据实际情况调整
                    imageLayer = new AMap.ImageLayer({
                        url: 'https://ezhou.hyr123.top/smartvillage/map.png', // 示例图片，需要根据实际情况配置
                        bounds: new AMap.Bounds(
                            [114.404839, 30.008525], // 西南角坐标
                            [115.183984, 30.628702] // 东北角坐标
                        ),
                        zooms: [15, 17],
                        zIndex: 9
                    });

                    // 初始状态：添加 TileLayer
                    tileLayer.setMap(map);

                    map.on('zoomchange', () => {
                        let z = map.getZoom();
                        if (z >= 14) {
                            map.setZoom(14);
                            return;
                        }

                        // 根据缩放级别切换图层
                        if (z >= 15) {
                            // 缩放级别 > 15，使用 ImageLayer
                            if (tileLayer) {
                                tileLayer.hide();
                            }
                            if (imageLayer) {
                                imageLayer.show();
                                if (!imageLayer.getMap()) {
                                    imageLayer.setMap(map);
                                }
                            }
                        } else {
                            // 缩放级别 <= 15，使用 TileLayer
                            if (imageLayer) {
                                imageLayer.hide();
                            }
                            if (tileLayer) {
                                tileLayer.show();
                                if (!tileLayer.getMap()) {
                                    tileLayer.setMap(map);
                                }
                            }
                        }
                    })
                    // 构造定位插件实例
                    map.plugin(["AMap.Geolocation"], function () {
                        geolocation = new AMap.Geolocation();
                        window.geolocation = geolocation;
                    });

                    AMap.plugin(["AMap.Driving"], function () {
                        map_driving = new AMap.Driving({
                            map: map,
                        });
                        map_driving.clear();
                    });

                    marker_locate = new AMap.Marker({
                        position: new AMap.LngLat(
                            121,
                            37
                        ),
                        // offset: new AMap.Pixel(-20, -50),
                        // icon: icon, // 添加 Icon 图标 URL
                        // anchor: 'bottom-center',
                    });
                    map.add(marker_locate);
                    marker_locate.hide();


                    setTimeout(() => {
                        // TileLayer 已在 zoomchange 事件前创建，这里不再重复创建

                        // let mdata = mapData;
                        if (mdata) {
                            for (let i = 0; i < mdata.length; i++) {
                                let d = mdata[i];
                                let lnglat;
                                if (d.coordinates) {
                                    lnglat = d.coordinates.split(',');
                                    let title = d.name;
                                    let icon = new AMap.Icon({
                                        // size: new AMap.Size(0, 0),
                                        size: new AMap.Size(20, 25),//要显示marker就改回来size
                                        image: '//hyr123.top/smartvillage_dev/iconblank.png',  // Icon的图像
                                        // imageOffset: new AMap.Pixel(0, -60),  // 图像相对展示区域的偏移量，适于雪碧图等
                                        imageSize: new AMap.Size(20, 25)
                                        // imageSize: new AMap.Size(0, 0)
                                    });

                                    console.log(d)
                                    let marker = new AMap.Marker({
                                        position: new AMap.LngLat(
                                            lnglat[0],
                                            lnglat[1]
                                        ),
                                        offset: new AMap.Pixel(10, 0),
                                        icon: icon, // 添加 Icon 图标 URL
                                        // anchor: 'bottom-center',
                                    });
                                    // marker.setAnimation("AMAP_ANIMATION_DROP")

                                    map.add(marker);
                                    arr_marker.push(marker);
                                    //data赋值
                                    marker.customdata = d

                                    let offsetX = -11 * title.length;

                                    let color = '#006837';
                                    if (d.category_id == 1) {
                                        color = '#C1272D';
                                    }
                                    else if (d.category_id == 2) {
                                        color = '#F15A24';
                                    }
                                    else if (d.range_readable == "美食") {
                                        color = '#4f8ed4';
                                    }
                                    else if (d.range_readable == "民宿") {
                                        color = '#8f7fbd';
                                    }
                                    else if (d.range_readable == "美丽乡村") {
                                        color = '#9d5b21';
                                    }
                                    console.log(d);

                                    marker.setLabel({
                                        offset: new AMap.Pixel(offsetX, 0),  //无图标，不要垂直偏移
                                        // offset: new AMap.Pixel(offsetX, 30),  //设置文本标注偏移量
                                        content: `<div style='background-color: rgba(255, 255, 255, 0.7);
                                            border: 1px ${color} solid;
                                            color:${color};
                                            border-radius: 15px;
                                            font-weight:bold;
                                            padding: 2px; 10px'>`+ title + `</div>`, //设置文本标注内容
                                        direction: 'right' //设置文本标注方位
                                    });
                                    // map.add(marker);
                                    marker.on("click", (e) => {
                                        // e.originEvent.stopPropagation();
                                        // e.originEvent.preventDefault();

                                        console.log('marker.customdata', marker.customdata);
                                        //点击触发业态 - planedata 应该始终使用 scenic 数据（marker.customdata），包含 desc 字段
                                        // fetchYetai 只用于获取业态列表，不用于设置 planedata
                                        dispatch(fetchYetai({ id: marker.customdata.id }));
                                        // planedata 始终使用 scenic 接口返回的数据（marker.customdata），确保包含 desc

                                        setTimeout(() => {
                                            setPlanedata(marker.customdata);
                                            setPlanedataId(marker.customdata.id);
                                            setPlaneTabIdx("4"); // 每次进入新点位重置到介绍
                                            setShowplane(true);
                                        }, 50)


                                    });
                                    marker.hide();
                                }
                            }
                        }

                        filterMakerHandler(1, "all");
                        setShowSubRange(false)
                    }, 300);

                    // setTimeout(() => {
                    //     // 确保二级面板显示
                    //     if (firstButtonRef.current) {
                    //         const rect = firstButtonRef.current.getBoundingClientRect();
                    //         setSubRangeTop(rect.top + window.scrollY);
                    //     }
                    //     filterMakerHandler(0, "all");
                    //     // 再次确保二级面板状态正确
                    //     setShowSubRange(true);
                    //     const defaultRanges = categoryMap.find(item => item.category_id === 1)?.range || [];
                    //     if (defaultRanges.length > 0) {
                    //         setSubRangeOptions(defaultRanges);
                    //     }
                    // }, 300);
                })
                .catch((e) => {
                    console.log(e);
                });
            // }
        }
        // 通过useDispatch 派发事件
        const newBoxTop = window.innerHeight - 600;
        setBoxTop(newBoxTop + 'px');

        setIsWeChatEnv(isWeChat());

        console.log('useEffect11111111111')
        dispatch(fetchScenic()).then(s => {
            console.log('useEffect2222222222')

            if (s.payload && !mapInit.current) {
                createMap(s);
            }

            else if (!s.payload) {
                console.log('useEffect4444444444')
                dispatch(fetchScenic()).then(_s => {
                    createMap(_s);
                });
            }

        });



        // 移除旧的 searchObject 处理逻辑，现在搜索逻辑已改为过滤 marker


        let dateNow = new Date().getFullYear().toString() + new Date().getMonth().toString() + new Date().getDate().toString()
        if (window.localStorage.getItem('splash') != dateNow) {

            dispatch(fetchSplash()).then(s => {
                setBool_splash(true);
                dispatch(SetSplashOpen(true));
                window.localStorage.setItem('splash', dateNow);
            });
        }
        if (!window.audio_bg) {
            let audio = document.getElementById('sound_bg');
            audio.setAttribute('autoplay', 'autoplay');
            audio.setAttribute('preload', 'preload');
            window.audio_bg = audio;
            audio.addEventListener('ended', function () {
                // 在音频播放完成时执行你想要的操作
                setAudioPlaying(false);
            });
        }

        return () => {
            if (map) {
                if (tileLayer) {
                    tileLayer.setMap(null);
                    tileLayer = null;
                }
                if (imageLayer) {
                    imageLayer.setMap(null);
                    imageLayer = null;
                }
                map.destroy();
                map = null;
                map_driving = null;
                geolocation = null;
            }

        };

    }, [])
    // })

    useEffect(() => {
        if (map_driving && currentRoute) {
            map_driving.search(currentRoute.startLngLat, currentRoute.endLngLat, { waypoints: currentRoute.waypoints }, function (status, result) {
                if (status === "complete") {
                    //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
                    //查询成功时，result 即为对应的驾车导航信息
                } else {
                    console.log("获取驾车数据失败：" + result);
                }
            });
        }

    }, [currentRoute])

    // 搜索过滤 marker（只在有搜索值时执行，避免与 filterMakerHandler 冲突）
    useEffect(() => {
        if (!map || arr_marker.length === 0) return;

        if (searchValue && searchValue.trim()) {
            // 有搜索关键词，只显示匹配的 marker（忽略分类和范围）
            const searchText = searchValue.trim();
            marker_locate?.hide();
            arr_marker.forEach(marker => {
                const markerName = marker.customdata?.name || '';
                if (markerName.includes(searchText)) {
                    marker.show();
                } else {
                    marker.hide();
                }
            });
        }
        // 搜索值为空时，不执行任何操作，让 filterMakerHandler 来控制显示
    }, [searchValue])

    return (
        <div>
            <style>{`
                @keyframes subRangeSlideIn {
                    from { opacity: 0; transform: translateX(12px); }
                    to { opacity: 1; transform: translateX(0); }
                }
            `}</style>
            <OpenScreen></OpenScreen>

            <div>
                <div
                    id="container"
                    style={{ height: "100vh", zIndex: 2, pointerEvents: "all" }}
                ></div>
                <ScrollingTextList texts={['123123123', 'zzzzzzzzzzz']}></ScrollingTextList>
                <div className='flex flex-col flex-wrap absolute right-2 h-full w-12 z-10 mt-20 ml-3' style={{ top: '5%' }}>
                    {/* <Link to="/yetai?type=2">
                        <MyButton>
                            <img src={img_icon0} alt="" />
                        </MyButton>
                    </Link>
                    <Link to="/yetai?type=1">
                        <MyButton>
                            <img src={img_icon2} alt="" />
                        </MyButton>
                    </Link>
                    <Link to="/yetai?type=3">
                        <MyButton>
                            <img src={img_icon1} alt="" />
                        </MyButton>
                    </Link>
                    {isWeChatEnv && <wx-open-launch-weapp
                        id="launch-btn"
                        // appid={"wxa00388f6f8d5534a"}
                        username={"gh_d2c5e2f3c551"}
                        path={"pages/webview/index.html?url=https%3A%2F%2Fwsnb.hzanchu.com%2Fvenue%2Fcity%2Fmaster%3FsiteId%3D6%26tempId%3D3293%26hiddenNav%3D1"}
                        error={(e) => { console.log(e) }}
                        launch={e => { console.log(e) }}
                        style={{ width: '48px', height: '60px', margin: '25px 0px 0 0', backgroundColor: 'rgba(0,0,0,0)' }}
                    >
                        <script type="text/wxtag-template">
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', backgroundColor: 'rgba(0,0,0,0)' }}>
                                <img src={bt_shop} style={{ borderRadius: '5px', opacity: 1, width: '100%', height: '100%' }} />
                            </div>
                        </script>
                    </wx-open-launch-weapp>} */}
                    {/* <BasicSpeedDial></BasicSpeedDial> */}
                    <MyButton onClick={() => { setShowNotificationDrawer(true) }}>
                        <img src={img_c8} alt="" />
                    </MyButton>

                    <MyButton onClick={lineHandler}>
                        <img src={img_c3} alt="" />
                    </MyButton>
                    <MyButton onClick={() => { alert('正在建设') }}>
                        <img src={img_live} alt="" />
                    </MyButton>
                    <MyButton onClick={addHandler} style={{ marginTop: "10px" }}>
                        <img src={img_add} alt="" />
                    </MyButton>
                    <MyButton onClick={minHandler} style={{ marginTop: "0px" }}>
                        <img src={img_min} alt="" />
                    </MyButton>

                    <MyButton onClick={locateHandler}>
                        <img src={img_icon6} alt="" />
                    </MyButton>
                </div>
                <div className='flex flex-col flex-wrap absolute left-2 top-16 h-full w-12 z-10 mt-20 mr-3' style={{ top: '5%' }}>
                    {/* <MyButton onClick={() => {
                        window.location.href = "http://wxfc8455181d8fd88b.wx.kcpai.com/pages/index/index"
                    }}>
                        <img src={img_icon10} alt="" />
                    </MyButton > */}
                    {/* <MyButton onClick={(e) => filterMakerHandler(0, "all", e)}>
                        <img src={img_icon7} alt="" />
                    </MyButton > */}
                    <div ref={firstButtonRef}>
                        <MyButton onClick={(e) => filterMakerHandler(1, "all", e)}>
                            <img src={img_c1} alt="" />
                        </MyButton >
                    </div>
                    <MyButton onClick={(e) => filterMakerHandler(2, "all", e)}>
                        <img src={img_c2} alt="" />
                    </MyButton>

                    <MyButton onClick={(e) => filterMakerHandler(4, "all", e)}>
                        <img src={img_c4} alt="" />
                    </MyButton>
                    {/* <MyButton onClick={(e) => filterMakerHandler(5, "all", e)}>
                        <img src={img_c5} alt="" />
                    </MyButton> */}
                    <MyButton onClick={(e) => filterMakerHandler(5, "美食")}>
                        <img src={img_c6} alt="" />
                    </MyButton>
                    <MyButton onClick={(e) => filterMakerHandler(5, "民宿")}>
                        <img src={img_c7} alt="" />
                    </MyButton>
                    <MyButton onClick={(e) => filterMakerHandler(5, "美丽乡村")}>
                        <img src={img_c5} alt="" />
                    </MyButton>
                    {/* <MyButton onClick={lineHandler}>
                        <img src={img_icon8} alt="" />
                    </MyButton> */}



                    {/* <MyButton onClick={clickHandler.bind(this, 5)}>
                    <img src={img_icon0} alt="" />
                </MyButton>
                <MyButton onClick={clickHandler.bind(this, 5)}>
                    <img src={img_icon0} alt="" />
                </MyButton> */}
                    {/* <Box>
                    <Button onClick={toggleDrawerFilter(true)}>筛选</Button>
                    <Drawer
                        anchor={"right"}
                        open={showfilter}
                        onClose={toggleDrawerFilter(false)}
                    >
                        <div>市/县</div>
                        <div>镇/街道</div>
                        <div>美丽乡村</div>
                    </Drawer>
                </Box> */}
                </div>
                {showSubRange && subRangeOptions.length > 0 && (
                    <div
                        className='absolute left-16 top-20 z-10 rounded-xl shadow-lg'
                        style={{
                            position: 'absolute',
                            background: 'rgba(255,255,255,0.7)',
                            backdropFilter: 'blur(6px)',
                            padding: '12px 6px 12px 6px',
                            maxWidth: '180px',
                            animation: 'subRangeSlideIn 0.28s ease forwards',
                            top: subRangeTop + 'px',
                            transition: 'top 0.25s ease, transform 0.25s ease, opacity 0.25s ease'
                        }}
                    >
                        <IconButton
                            size="small"
                            onClick={() => setShowSubRange(false)}
                            sx={{
                                position: 'absolute',
                                top: 4,
                                left: 4,
                                color: '#607080',
                                '&:hover': { color: '#304050', backgroundColor: 'rgba(0,0,0,0.04)' }
                            }}
                        >
                            <CancelOutlinedIcon fontSize="small" />
                        </IconButton>
                        <div className='flex flex-col space-y-2 mt-6'>
                            {subRangeOptions.length > 0 && <Button
                                fullWidth
                                variant={selectedRange === "all" ? "contained" : "outlined"}
                                size="small"
                                onClick={() => filterMakerHandler(selectedCategoryId, "all")}
                                sx={{
                                    textAlign: 'left',
                                    justifyContent: 'flex-start',
                                    backgroundColor: selectedRange === "all" ? '#f0f6ff' : 'transparent',
                                    color: '#1f2933',
                                    borderColor: '#d5e2f2',
                                    border: 'none',
                                    '&:hover': { backgroundColor: '#e8f1ff' }
                                }}
                            >
                                全部
                            </Button>
                            }
                            {subRangeOptions && subRangeOptions.map((range) => (
                                <Button
                                    key={range}
                                    fullWidth
                                    variant={selectedRange === range ? "contained" : "outlined"}
                                    size="small"
                                    onClick={() => filterMakerHandler(selectedCategoryId, range)}
                                    sx={{
                                        textAlign: 'left',
                                        justifyContent: 'flex-start',
                                        backgroundColor: selectedRange === range ? '#f0f6ff' : 'transparent',
                                        color: '#666666',
                                        borderColor: '#fff',
                                        border: '0px',
                                        '&:hover': { backgroundColor: '#e8f1ff' }
                                    }}
                                >
                                    {range}
                                </Button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <Splash open={bool_splash} handleClose={splashCloseHandler}></Splash>

            {<MyPlane
                audioPlaying={audioPlaying}
                closeHandler={toggleDrawer(false)}
                showplane={showplane}
                data={planedata}
                initialTab={planeTabIdx}
                onTabChange={setPlaneTabIdx}
            ></MyPlane>}
            {<Line showLine={showLine} closeHandler={closeLineHandler()}></Line>}
            {/* 通知 Drawer - 显示 stype == 3 的数据 */}
            <Drawer
                anchor="bottom"
                open={showNotificationDrawer}
                onClose={() => setShowNotificationDrawer(false)}
                sx={{
                    '& .MuiPaper-root': {
                        borderTopLeftRadius: '15px !important',
                        borderTopRightRadius: '15px !important',
                        maxHeight: '80vh',
                    },
                }}
            >
                <Box sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', padding: '10px' }}>
                    <IconButton
                        style={{ position: 'absolute', right: '10px', top: '10px' }}
                        aria-label="close"
                        size="medium"
                        onClick={() => setShowNotificationDrawer(false)}
                    >
                        <HighlightOffSharpIcon fontSize="medium" />
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 40px 10px 10px' }}
                    >
                        农业概况
                    </Typography>
                    <video src="https://ezhou.hyr123.top/smartvillage/1.mp4" preload="metadata" style={{ width: '100%', height: 'auto', objectFit: 'cover', minHeight: '190px' }} controls poster="https://ezhou.hyr123.top/smartvillage/poster.png"></video>
                </Box>
                <Container sx={{ paddingTop: 2, paddingBottom: 4, overflowY: 'auto', maxHeight: 'calc(80vh - 60px)' }}>
                    {notificationData && notificationData.length > 0 ? (
                        notificationData
                            .filter(item => item.stype == 3)
                            .map((item, index) => (
                                <Box key={index} sx={{ mb: 3, pb: 2, borderBottom: index < notificationData.filter(i => i.stype == 3).length - 1 ? '1px solid #eee' : 'none' }}>
                                    <Typography
                                        component="div"
                                        variant="body1"
                                        dangerouslySetInnerHTML={{ __html: item.desc }}
                                        sx={{ fontSize: '0.9rem', color: '#333', lineHeight: 1.6 }}
                                    />
                                </Box>
                            ))
                    ) : (
                        <Typography sx={{ textAlign: 'center', color: '#999', padding: '40px 0' }}>
                            暂无通知
                        </Typography>
                    )}
                </Container>
            </Drawer>
        </div >
    );
}